/*
 * @Author: 左建
 * @Date: 2022-06-12 21:02:21
 * @LastEditTime: 2022-06-12 21:03:21
 * @Description: 责任链模式
 **/
function syncFnResultHandler () {
    const result = this.fn(this.result)
    this.chain__status = result === false ? "fail" : "success"
    this.status = result === false ? "fail" : "success"
    this.fail__step = result === false ? this.step : 1
    this.fail__id = result === false ? this.id : undefined
    return result
}

export default class ResponsibilityChain {
    constructor(fn, id = "", step = 1, result, chain__status = "padding", fail__step = 0, fail__id, last__step__id) {
        this.fn = fn // 当前步骤的运行函数
        this.id = id // 当前步骤的id，可以用来充当该步骤的描述
        this.status = "padding" // 当前步骤的状态
        this.chain__status = chain__status // 整个责任链状态
        this.step = step // 当前第几步
        this.result = result // 当前步骤运行结果
        this.fail__step = fail__step // 第几步失败
        this.fail__id = fail__id // 失败的id
    }

    // 下一步
    syncNext (fn, id) {
        let result
        if (this.chain__status !== "fail") {
            result = syncFnResultHandler.bind(this)()
        }
        return new ResponsibilityChain(fn, id, this.step + 1, result, this.chain__status, this.fail__step, this.fail__id)
    }
    /**
     * 结束
     * @param [isLog] { boolean } // 是否需要打印责任链错误日志
     * @return instance of ResponsibilityChain
     */
    syncEnd (isLog) {
        if (this.chain__status !== "fail") {
            syncFnResultHandler.bind(this)()
        }
        if (this.chain__status === "fail" && isLog !== false) {
            console.error(`责任链失败, 失败原因：第${this.fail__step}步---${this.id}失败`)
        }
        return this
    }
}
